import { useMutation, useQueryClient } from 'react-query';
import axios from 'api/axiosInstance';
import { ToastManager } from 'components/organisms/CommonUI';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { fetchPatientList } from 'store/middleware';

export const useRestorePatient = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationFn: async (patientId: number) => {
      const response = await axios.put(`/api/v1/patients/${patientId}/restore`);
      return response.data;
    },
    onSuccess: async () => {
      // 삭제된 환자 목록 갱신
      queryClient.invalidateQueries({ queryKey: ['deletedPatients'] });
      
      // Redux store의 환자 목록 업데이트 (forceRefresh: true)
      try {
        await dispatch(
          fetchPatientList({ forceRefresh: true })
        ).unwrap();
      } catch (error) {
        console.error('Failed to update patient list in Redux store:', error);
      }
      
      ToastManager.show({
        content: '환자가 복원되었습니다.',
        duration: 2000,
      });
    },
    onError: (error: any) => {
      const errorMessage = error.response?.status === 403 
        ? '복원 권한이 없습니다.' 
        : '환자 복원에 실패했습니다.';
      
      ToastManager.show({
        content: errorMessage,
        duration: 3000,
      });
    },
  });
};